import { terrainHeight } from "./terrain";

export interface Surface {
  heightAt(x: number, z: number): number | null;
}

export function disc(x: number, z: number, radius: number, height: number): Surface {
  const squared = radius * radius;
  return {
    heightAt(px: number, pz: number): number | null {
      const dx = px - x;
      const dz = pz - z;
      return dx * dx + dz * dz <= squared ? height : null;
    },
  };
}

export function rect(
  x: number,
  z: number,
  halfWidth: number,
  halfDepth: number,
  height: number,
  yaw = 0,
): Surface {
  const cos = Math.cos(-yaw);
  const sin = Math.sin(-yaw);
  return {
    heightAt(px: number, pz: number): number | null {
      const dx = px - x;
      const dz = pz - z;
      const localX = dx * cos - dz * sin;
      const localZ = dx * sin + dz * cos;
      return Math.abs(localX) <= halfWidth && Math.abs(localZ) <= halfDepth ? height : null;
    },
  };
}

export class Ground {
  private readonly surfaces: Surface[] = [];

  add(surface: Surface): void {
    this.surfaces.push(surface);
  }

  heightAt(x: number, z: number): number {
    let height = terrainHeight(x, z);
    for (const surface of this.surfaces) {
      const value = surface.heightAt(x, z);
      if (value !== null && value > height) height = value;
    }
    return height;
  }
}
